import { configureStore } from '@reduxjs/toolkit';
import authenticationReducer from './authentication';
import dashboardReducer from './dashboard';
import searchReducer from './search';

const store = configureStore({
  reducer:{
    auth: authenticationReducer,
    dashboard: dashboardReducer,
    search: searchReducer,
  }
});

//defined RootState and AppDispatch type interface for dispatch and selector
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;